import NumberFormat from "react-number-format"
import moment from "moment"

export const BoxFlows = ({ flow }) => {
    return (
        <span>
            <span className="mr-1">
                {flow?.tipo_flujo === 'ingreso' ?
                    <span className="text-green-700">
                        <i className="bi bi-arrow-up-short text-green-700 text-[14px]"></i>
                        <span >flujo Ingreso</span>
                    </span>
                    :
                    <span className="text-red-600">
                        <i className="bi bi-arrow-down-short text-red-600 text-[14px]"></ i>
                        <span>flujo Egreso</span>
                    </span>
                }
            </span>
            ( <span className="me-1">{moment(flow?.fecha_proyeccion).format('DD-MM-YYYY')}</span> |
            <NumberFormat
                displayType={'text'}
                className="ms-1 me-1"
                value={flow?.tipo_flujo === 'ingreso' ?
                    parseFloat(flow?.monto_neto || 0) :
                    parseFloat(flow?.total || 0)
                }
                thousandSeparator={flow?.separacion_miles || ','}
                decimalSeparator={flow?.separacion_decimales || '.'}
                prefix={`${flow?.simbolo || 'S/ '} `}
                decimalScale={2}
                fixedDecimalScale={2}
            />
            |<span className="ms-1 me-1" title={flow.nombre_completo}>{flow.nombre}...</span>
            |<span className="ms-1" style={{ color: flow.estado === 'pagada' ? 'green' : '' }}>{flow.estado}</span> )
        </span>
    )
}